import Vue from 'vue'

import cPage from './cPage'
import cManage from './cManage'
import cImport from './cImport'
import cCalendar from './cCalendar'
// import cDynamic from './cDynamic'

Vue.component('c-page', cPage)
Vue.component('c-manage', cManage)
Vue.component('c-import', cImport)
Vue.component('c-calendar', cCalendar)
// Vue.component('c-dynamic', cDynamic)
